export const useGetParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+ ');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',
  };
};
